import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/Services/auth.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-upgrade-account',
    templateUrl: './upgrade-account.component.html',
    styleUrls: ['./upgrade-account.component.css'],
    standalone: false
})
export class UpgradeAccountComponent {
  showUpgradeModal: boolean = false;
  isUpgrading: boolean = false;

  constructor(
    private authService: AuthService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private transloco: TranslocoService
  ) {}

  public openUpgradeModal(): void {
    this.showUpgradeModal = true;
  }

  public closeUpgradeModal(): void {
    if (!this.isUpgrading) {
      this.showUpgradeModal = false;
    }
  }

  public upgradeAccount(): void {
    this.isUpgrading = true;
    this.ngxSpinnerService.show();

    this.authService.upgradeToFullArtist().subscribe(
      (response) => {
        if (response.Success) {
          this.authService.removeGalleryEventId();

          this.ngxSpinnerService.hide();
          this.isUpgrading = false;
          this.showUpgradeModal = false;

          this.notificationsService.showNotification(
            this.transloco.translate('upgradeAccount.successTitle'),
            this.transloco.translate('upgradeAccount.upgradeSuccess'),
            NotificationTypes.Success
          );
        } else {
          this.ngxSpinnerService.hide();
          this.isUpgrading = false;

          this.notificationsService.showNotification(
            this.transloco.translate('upgradeAccount.errorTitle'),
            response.ResponseMessage || this.transloco.translate('upgradeAccount.upgradeFailed'),
            NotificationTypes.Error
          );
        }
      },
      (error) => {
        console.error('Upgrade error:', error);
        this.ngxSpinnerService.hide();
        this.isUpgrading = false;

        this.notificationsService.showNotification(
          this.transloco.translate('upgradeAccount.errorTitle'),
          this.transloco.translate('upgradeAccount.upgradeError'),
          NotificationTypes.Error
        );
      }
    );
  }
}
